<div class="login-form-container w-100 h-100 main-panel">
  <div class="w-100 mx-auto d-flex align-items-center justify-content-center flex-column gap-3">
    <div style="max-width: 300px" class="mx-auto d-block w-100">
      <div class="login-details-logo-container w-100">
        <img src="/assets/images/logo.png" style="max-width: 60px" class="w-100 d-block mx-auto" />
        <p class="text monek-font">MONEK</p>
      </div>
      <form class="w-100 mx-auto">

        <p class="text-center d-block mb-3 w-100 fs-3">Forgot Password</p>
        <!-- bootstrap style email and password -->
        <div class="form-item mb-3 mx-0 w-100">
          <label for="email" class="form-label">Email</label>
          <input type="email" data-test="forgot-email" id="email" class="form-control form-control-lg" placeholder="Enter your email"
                 [(ngModel)]="email" name="email" required />
        </div>

        <button class="w-100 mt-4 form-item mon-bg-primary mon-text-primary" data-test="submit-button" mat-flat-button
                (click)="Submit()">
          <span>SUBMIT</span>
        </button>

        <div class="mt-3">
          <a class="d-block w-100 text-decoration-underline text-center text-dark" href="/authentication/login">Login Here</a>
        </div>

      </form>
    </div>

    <odin-loading-spinner [active]="loading" [overlay]="true"></odin-loading-spinner>
  </div>
</div>
